import React from "react";
import BarChart from "./BarChart/BarChart";
import AreaChart from "./AreaChart/AreaChart";
import TableChart from "./TableChart";

const Chart = ({
  type = "barchart",
  title = "Title",
  noTitle = false,
  data,
  height,
  width,
  steps,
  showHorizontalGrid,
  showVerticalGrid,
  showValueLabel,
  barWidth,
  barRadius,
  formatYAxisTick,
  formatXAxisTick,
  color,
  depth,
  noImage = true,
  gradientFrom,
  gradientTo,
  strokeColor,
  isHover,
  backgroundColor,
  columns,
  rows,
  showSlNo,
  showCheckbox,
  hideToolBar,
  toolbarRight,
  renderToolTip,
}) => {
  const renderField = () => {
    switch (type) {
      case "barchart":
        return (
          <BarChart
            data={data}
            width={width}
            height={height}
            steps={steps}
            showHorizontalGrid={showHorizontalGrid}
            showVerticalGrid={showVerticalGrid}
            showValueLabel={showValueLabel}
            barWidth={barWidth}
            barRadius={barRadius}
            formatYAxisTick={formatYAxisTick}
            formatXAxisTick={formatXAxisTick}
            color={color}
            depth={depth}
            backgroundColor={backgroundColor}
          />
        );

      case "areachart":
        return (
          <AreaChart
            data={data}
            width={width}
            height={height}
            steps={steps}
            showHorizontalGrid={showHorizontalGrid}
            showVerticalGrid={showVerticalGrid}
            formatYAxisTick={formatYAxisTick}
            formatXAxisTick={formatXAxisTick}
            gradientFrom={gradientFrom}
            gradientTo={gradientTo}
            strokeColor={strokeColor}
            backgroundColor={backgroundColor}
            isHover={isHover}
            renderToolTip={renderToolTip}
          />
        );

      case "tablechart":
        return (
          <TableChart
            columns={columns}
            rows={rows}
            height={height}
            width={width}
            noImage={noImage}
            hideToolBar={hideToolBar}
            showSlNo={showSlNo}
            showCheckbox={showCheckbox}
            toolbarRight={toolbarRight}
          />
        );

      default:
        return null; // You can render a default component if needed
    }
  };
  return (
    <div className="flex flex-col h-full w-full ">
      {!noTitle && (
        <span className="text-md font-semibold text-gray-600 mb-2">
          {title}
        </span>
      )}
      {renderField()}
    </div>
  );
};

export default Chart;
